import DisplayField from '@/components/ui/DisplayField'
import EditActions from '@/components/ui/EditActions'
import resizing from '@/utils/resizing'

export default {
  components: { DisplayField, EditActions },
  mixins: [resizing],
  props: {
    items: {
      type: [Object, Array],
      required: true
    },
    submitLabel: {
      type: String,
      default: 'Salvar'
    },
    btnCancelLabel: {
      type: String,
      default: 'Cancelar'
    },
    btnCancelShow: {
      type: Boolean,
      default: false
    },
    btnPosition: {
      type: String,
      default: 'right'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideSubmit: {
      type: Boolean,
      default: false
    },
    displayMode: {
      type: Boolean,
      default: false
    },
    actionsEdit: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    btnOutline: {
      type: Boolean,
      default: false
    },
    btnBlock: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: true,
      isDisabled: false,
      dataItems: {},
      isDisplayMode: true
    }
  },
  methods: {
    submit () {
      console.log('submit', this.validate)
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.dataItems)
        this.isDisabled = this.editAction
      }
    },
    edit () {
      this.$emit('edit')
    },
    cancel () {
      this.$emit('cancel')
    },
    changeDisplay (status) {
      this.isDisplayMode = status
    },
    save () {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.dataItems)
        this.isDisplayMode = true
      }
    },
    validation () {
      return this.$refs.form.validate()
    }
  },
  computed: {
    setAutoHeight () {
      return this.autoHeight ? this.setHeightScroll : ''
    },
    setStyleEditMode () {
      return this.actionsEdit ? 'margin-top: -47px' : ''
    }
  },
  watch: {
    isDisplayMode (val) {
      this.$emit('displayMode', val)
    },
    items (val) {
      // this.isDisplayMode = true
      this.dataItems = val
    },
    valid () {
      this.$emit('validate', this.valid)
    }
  },
  mounted () {
    this.isDisplayMode = this.displayMode
    this.dataItems = Object.assign({}, this.items)
  }
}
